import axios, { CancelTokenSource } from 'axios';
import { APIFactory } from '../../../rest/APIFactory';
import QueryString from 'qs';
import { baseUrlService } from '../../../rest/BaseUrlService';
import { eUSAState } from '../../../enums/states';
import { axiosErrorHandler } from '../../../rest/axiosErrorHandler';
import {
  ISearchOrdersSpecificationData,
  convertFromSearchOrdersSpecificationRequestToParameters,
} from '../types/ISearchOrdersSpecification';
import {
  convertFromSearchOrderResultRequestToSearchOrderResultData,
  ISearchOrderResultData,
  ISearchOrderResultRequest,
} from '../types/ISearchOrdersResult';
import { convertFromCountyResponseArrayToCountyDataArray, ICountyData } from '../types/ICounty';

export const cancelSearchErrorMessage = 'Operation canceled due to new request.';
let cancelToken: CancelTokenSource | undefined = undefined;

export const searchByParameters = async (
  parameters: ISearchOrdersSpecificationData
): Promise<ISearchOrderResultData> => {
  //Check if there are any previous pending requests
  if (cancelToken && !parameters.allowMultiple) {
    cancelToken.cancel(cancelSearchErrorMessage);
  }

  //Save the cancel token for the current request
  cancelToken = axios.CancelToken.source();
  return APIFactory(baseUrlService.ApiLocation)
    .get<ISearchOrderResultRequest>(
      `/timber/api/internal/orders?${QueryString.stringify(
        convertFromSearchOrdersSpecificationRequestToParameters(parameters),
        {
          arrayFormat: 'repeat',
        }
      )}`,
      {
        cancelToken: cancelToken.token,
      }
    )
    .then((response) => convertFromSearchOrderResultRequestToSearchOrderResultData(response.data))
    .catch(axiosErrorHandler);
};

export const searchByParametersClient = async (
  parameters: ISearchOrdersSpecificationData,
): Promise<ISearchOrderResultData> =>
  APIFactory(baseUrlService.ApiLocation)
    .post<ISearchOrderResultRequest>(
      `lender/v1/client/orders`,
      convertFromSearchOrdersSpecificationRequestToParameters(parameters)
    )
    .then((response) => convertFromSearchOrderResultRequestToSearchOrderResultData(response.data))
    .catch(axiosErrorHandler);

export const getCountyForState = async (state: eUSAState): Promise<ICountyData[]> =>
  APIFactory(baseUrlService.ApiLocation)
    .get(`/lender/v1/counties?state=${state}`)
    .then((response) => convertFromCountyResponseArrayToCountyDataArray(response.data.counties))
    .catch(axiosErrorHandler);
